/**
 * TasksPage — page-level entry, delegates to the feature module.
 *
 * The feature lives at `apps/web/kakehashi/web/src/features/tasks/` and ships
 * the full Notion-style task surface (rich properties / subtasks / dependencies
 * / Kanban / Gantt) wired to `apps/web/kakehashi/api/src/routes/tasks.ts`.
 *
 * See: skill-bridge/media_app#5992 / docs/chatwork_killer/06_task_file_org.md
 */
import { useSearchParams } from "react-router-dom";
import { TasksPage as TasksFeaturePage } from "@/features/tasks";

import { useMembers } from "@/lib/workspace";
import { TopBar } from "@/components/TopBar";
import { useTaskAccess } from "@/features/tasks/access";
import { TaskAccessPanel } from "@/features/tasks/TaskAccessPanel";

export function TasksPage(): JSX.Element {
  const { members, error, workspace } = useMembers();
  const access = useTaskAccess(workspace?.id);
  // /tasks?task=<id> is where a task-assignment notification lands: the page opens that task's detail panel.
  const [params] = useSearchParams();
  return <><TopBar title="タスク" />
    <div className="min-h-0 flex-1 overflow-y-auto bg-surface-base md:flex md:flex-col md:overflow-hidden">
      {error && <p role="alert" className="p-3 text-danger">担当者一覧を取得できませんでした: {error.message}</p>}
      {access.error && <div role="alert" className="p-3 text-danger">タスク権限を取得できませんでした: {access.error.message}<button type="button" onClick={() => void access.refetch()} className="ml-3 min-h-11 rounded-md border border-border-default px-3 text-fg-secondary">再読み込み</button></div>}
      {access.isPending && <p role="status" className="p-3 text-fg-muted">タスクを読み込んでいます…</p>}
      {access.isSuccess && access.data && <TaskAccessPanel access={access.data} />}
      {access.isSuccess && access.data && <TasksFeaturePage key={workspace?.id} members={members} access={access.data} onRefreshAccess={() => access.refetch()} initialTaskId={params.get("task") ?? undefined} />}
    </div>
  </>;
}
